
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-path-help-modal',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in" (click)="close.emit()">
      <div class="bg-gray-800 border border-gray-700 rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="p-6 sm:p-8 space-y-6">
          <div class="flex justify-between items-start">
            <h2 class="text-2xl font-bold text-gray-100">Как добавить TwitchDownloaderCLI в PATH?</h2>
            <button (click)="close.emit()" class="text-gray-400 hover:text-white transition-colors p-1 -mt-2 -mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div class="text-gray-400 space-y-2 text-sm">
            <p>
              Добавление программы в <code>PATH</code> позволяет вызывать её по имени из любой папки в терминале. Это необходимо, чтобы наши скрипты для загрузки работали корректно, где бы вы их ни сохранили.
            </p>
          </div>

          <div class="space-y-4">
            <h3 class="text-xl font-semibold text-indigo-400 border-b border-gray-700 pb-2">Инструкция для Windows (10/11)</h3>
            <ol class="list-decimal list-inside space-y-3 text-gray-300 text-sm">
              <li>
                <strong>Скопируйте путь к папке:</strong> 
                <br/>
                Найдите, куда вы распаковали <code>TwitchDownloader</code>, и скопируйте путь к этой папке из адресной строки проводника (например, <code class="bg-gray-900/80 text-indigo-300 text-xs px-1.5 py-1 rounded">C:\\Users\\Имя\\Downloads\\TwitchDownloader</code>).
              </li>
              <li>
                <strong>Откройте настройки переменных среды:</strong>
                <br/>
                Нажмите "Пуск", введите <kbd class="px-2 py-1 text-xs font-semibold text-gray-300 bg-gray-600 border border-gray-500 rounded-lg">переменные среды</kbd> и выберите "Изменение системных переменных среды".
              </li>
              <li>
                В открывшемся окне нажмите на кнопку <strong>"Переменные среды..."</strong>.
              </li>
              <li>
                В верхнем списке ("Переменные среды пользователя") выберите строку с именем <code>Path</code> и нажмите <strong>"Изменить..."</strong>.
              </li>
               <li>
                В новом окне нажмите <strong>"Создать"</strong> и вставьте скопированный путь.
              </li>
               <li>
                Нажмите <strong>"ОК"</strong> на всех окнах для сохранения. <strong>Перезапустите терминал</strong>, если он был открыт.
              </li>
            </ol>
          </div>
          
          <div class="space-y-4">
            <h3 class="text-xl font-semibold text-indigo-400 border-b border-gray-700 pb-2">Инструкция для macOS / Linux</h3>
            <ol class="list-decimal list-inside space-y-3 text-gray-300 text-sm">
              <li>
                <strong>Скопируйте путь к папке:</strong> 
                <br/>
                 Откройте терминал, перетащите в него папку с <code>TwitchDownloaderCLI</code> и скопируйте появившийся путь (например, <code class="bg-gray-900/80 text-indigo-300 text-xs px-1.5 py-1 rounded">/Users/Имя/Tools/TwitchDownloader</code>).
              </li>
              <li>
                <strong>Откройте конфигурационный файл:</strong>
                <br/>
                Выполните в терминале <code class="bg-gray-900/80 text-indigo-300 text-xs px-1.5 py-1 rounded">nano ~/.zshrc</code> (для macOS) или <code class="bg-gray-900/80 text-indigo-300 text-xs px-1.5 py-1 rounded">nano ~/.bashrc</code> (для Linux).
              </li>
              <li>
                <strong>Добавьте путь:</strong>
                <br/>
                В самый конец файла добавьте строку, заменив путь на свой:
                <pre class="bg-gray-900/80 text-indigo-300 text-xs p-2 mt-1 rounded font-mono"><code>export PATH="/путь/к/вашей/папке:$PATH"</code></pre>
              </li>
               <li>
                Нажмите <kbd class="px-2 py-1 text-xs font-semibold text-gray-300 bg-gray-600 border border-gray-500 rounded-lg">Ctrl+X</kbd>, затем <kbd class="px-2 py-1 text-xs font-semibold text-gray-300 bg-gray-600 border border-gray-500 rounded-lg">Y</kbd> и <kbd class="px-2 py-1 text-xs font-semibold text-gray-300 bg-gray-600 border border-gray-500 rounded-lg">Enter</kbd> для сохранения.
              </li>
               <li>
                Примените изменения командой <code class="bg-gray-900/80 text-indigo-300 text-xs px-1.5 py-1 rounded">source ~/.zshrc</code> (или <code>~/.bashrc</code>) или просто перезапустите терминал.
              </li>
            </ol>
          </div>

           <div class="space-y-3 pt-4 border-t border-gray-700">
            <h3 class="text-xl font-semibold text-indigo-400">Проверка</h3>
            <p class="text-gray-400 text-sm">
              Откройте <strong>новое</strong> окно терминала и введите команду ниже. Если вы увидите версию программы, а не ошибку — всё настроено правильно!
            </p>
            <pre class="bg-gray-900/80 text-indigo-300 text-sm p-3 rounded font-mono"><code>TwitchDownloaderCLI --version</code></pre>
          </div>

        </div>
      </div>
    </div>
  `
})
export class PathHelpModalComponent {
  @Output() close = new EventEmitter<void>();
}
